<template>
  <div>
    <component :is="view"></component>
  </div>
</template>

<script>
export default {
  name: "PlaceOrderRedirectComponent",
  title: "Dashboard",
  computed: {
    view() {
      if (this.$store.getters.loggedIn) {
        const type = this.$store.getters.getUser.type;
        return type === "HOTEL" || type === "RESTAURANT"
          ? "hotel-view"
          : type === "COMPANY"
          ? "hotel-view"
          : "none";
      }
      return "none";
    },
  },
};
</script>
